export const isDevelopmentMode = process.env?.NODE_ENV?.toLowerCase() === "development";
export const getSplitConfig = ({ authorizationKey, features, userKey, logImpression, }) => {
    return {
        core: {
            authorizationKey: authorizationKey ?? "localhost",
            key: userKey,
        },
        ...(logImpression && { impressionListener: { logImpression } }),
        ...(features && { features }),
    };
};
//# sourceMappingURL=split-factory.helpers.js.map